import config from 'app/config';

export const hrefToNext = (href) =>
    href.startsWith(`${config.nextURI}`) ? href : `${config.nextURI}${href}`;
